import styled from 'styled-components';
import List from './component';

export default styled(List)`
  padding: 0 8px;

  .list__title {
    color: white;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;

    &--eye-list {
      margin-top: 24px;
    }
  }

  .list__content {
    &--eye-list {
      margin-bottom: 120px;
    }
  }

  .no-tasks {
    color: white;
  }
`;
